/* Purpose: fit enabled native/custom heroes to real first-screen space, including
 * wrapped announcement messages. Geometry only; native carousel, menus and links
 * retain ownership. Re-mount on Shopify section replacement; no scroll handler. */
(() => {
  if (window.mvkHeroLoaded) return;
  window.mvkHeroLoaded = true;
  let cleanup = () => {};
  function mount() {
    cleanup();
    const roots = [...document.querySelectorAll('[data-mvk-hero]')];
    if (!roots.length) return;
    let frame, disposed = false;
    const html = document.documentElement;
    function measure() {
      if (disposed) return;
      const headerRoot = document.querySelector('[data-mvk-header]');
      const category = roots[0].querySelector('.maverickCatagoryLayout');
      const banner = roots[0].querySelector('[class*="maverickbannerslider-"]');
      const categoryFirst = category && banner && !!(category.compareDocumentPosition(banner) & Node.DOCUMENT_POSITION_FOLLOWING);
      const requestedOverlay = headerRoot?.dataset.mvkMobileOverlay === 'true' && document.getElementById('SiteHeader')?.dataset.overlay === 'true';
      const overlay = requestedOverlay && !categoryFirst;
      html.classList.toggle('mvk-hero-header-overlay', overlay);
      // The editor can move light category shortcuts back above the image. Keep
      // navigation readable there without overwriting its saved overlay setting.
      html.classList.toggle('mvk-hero-solid-header', requestedOverlay && categoryFirst);
      roots.forEach(root => {
        const media = [...root.querySelectorAll('.hero, [class*="maverickbannerslider-"]')].find(el => el.getBoundingClientRect().width > 0);
        if (!media) return;
        // Document position is stable while scrolling; recompute on layout/font
        // changes. Never subtract the header twice when it overlays the image.
        const top = Math.max(0, media.getBoundingClientRect().top + scrollY);
        root.style.setProperty('--mvk-hero-top', top + 'px');
        // Long merchant translations grow the hero instead of hiding copy/CTAs.
        // Default accepted content is checked to fit the first viewport.
        const copies = [...root.querySelectorAll('.hero__text-shadow, .maverickBannersContent')].filter(el => el.getBoundingClientRect().width > 0);
        // The legacy native text-shadow pseudo-element extends 100px outside its
        // box. Measure actual copy bounds, not scrollHeight including that shadow.
        const tallest = Math.max(0, ...copies.map(el => el.getBoundingClientRect().height));
        const headerHeight = document.getElementById('SiteHeader')?.offsetHeight || 64;
        root.style.setProperty('--mvk-hero-content-min', (tallest + headerHeight + (innerHeight <= 500 ? 40 : 80)) + 'px');
      });
    }
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); };
    const resize = new ResizeObserver(schedule);
    // The pinned announcement changes the header's padding, not its content box.
    // Border-box observation catches that second layout pass after wrapped copy.
    [document.querySelector('[data-mvk-header]'), document.querySelector('.announcement-bar'), ...roots.map(root => root.closest('.shopify-section'))].filter(Boolean).forEach(el => resize.observe(el, {box:'border-box'}));
    window.addEventListener('resize', schedule);
    document.fonts?.ready.then(() => { if (!disposed) schedule(); });
    measure();
    cleanup = () => { disposed=true;cancelAnimationFrame(frame);resize.disconnect();window.removeEventListener('resize',schedule);html.classList.remove('mvk-hero-header-overlay','mvk-hero-solid-header'); };
  }
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', mount);
  mount();
})();
